import { gql } from "@apollo/client";

// Query: Get a specific LibraryCard
export const GET_LIBRARY_CARD_QUERY = gql`
  query GetLibraryCard($input: GetLibraryCardInput!) {
    getLibraryCard(input: $input) {
      startup
      entityType
      entityId
      data
      bucket
      s3Url
      thumbnailUrl
      tags
      createdAt
    }
  }
`;

// Query: List LibraryCards for a tenant and entity type
export const LIST_LIBRARY_CARDS_QUERY = gql`
  query ListLibraryCards($input: ListLibraryCardsInput!) {
    listLibraryCards(input: $input) {
      pageNames
    }
  }
`;

// Mutation: Save a LibraryCard
export const SAVE_LIBRARY_CARD_MUTATION = gql`
  mutation SaveLibraryCard($input: SaveLibraryCardInput!) {
    saveLibraryCard(input: $input) {
      success
      message
    }
  }
`;

// Mutation: Handle file uploads via presigned URLs
export const PUT_FILE_EVENT_MUTATION = gql`
  mutation PutFileEvent($input: PutFileEventInput!) {
    putFileEvent(input: $input) {
      presignedUrl
      message
    }
  }
`;

// Query: Fetch presigned URLs for uploading files
export const GET_PRESIGNED_URLS_QUERY = gql`
  query GetPresignedUrls($input: PresignedUrlsInput!) {
    getPresignedUrls(input: $input) {
      presignedUrls
    }
  }
`;

// input PresignedUrlsInput {
//   operationType: String!
//   entityType: String!
//   fileNames: [String!]!
// }
